export { default } from "./CategoryCollectionDividedByDate";
